import { LOCATION_CHANGE } from 'react-router-redux';
import { setMenuOpen, setShareWidgetOpen } from '../actions/uiActions';


const uiMiddleware = store => next => action => {
  if (action.type === LOCATION_CHANGE && store.getState().ui.menuIsOpen) {
    store.dispatch(setMenuOpen(false));
  }

  if (action.type === LOCATION_CHANGE && store.getState().ui.shareWidgetIsOpen) {
    store.dispatch(setShareWidgetOpen(false));
  }

  next(action);
};

export default uiMiddleware;



// WEBPACK FOOTER //
// ./src/middleware/uiMiddleware.js